"use strict";
'use es6'; // Adds configured higher-order component wrappers to the interaction component.
// By convention, it is the responsibility of the last wrapper to maintain the
// state of the interaction.

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Interaction;

function Interaction(descriptor) {
  var WrappedInteractionComponent = descriptor.Component;
  descriptor.wrappers.forEach(function (Wrapper) {
    WrappedInteractionComponent = Wrapper(WrappedInteractionComponent, descriptor.type);
  });
  return WrappedInteractionComponent;
}

module.exports = exports.default;